/**
 * WebsiteGallery — projects/portfolio strip.
 * Uses CSS-generated swatch tiles when no images supplied
 * (so we ship without third-party image hosting risks).
 */
export default function WebsiteGallery({ config }) {
  const projects = Array.isArray(config.projects) ? config.projects : [];
  if (!projects.length) return null;
  const primary = config.brand?.primary || '#0f4c81';
  const accent = config.brand?.accent || '#f59e0b';
  const swatch = (idx) => idx % 2 ? accent : primary;

  return (
    <section id="projects" className="py-20 lg:py-24 bg-white" data-testid="ws-gallery">
      <div className="max-w-6xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl mb-10 lg:mb-12">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-slate-500 mb-2.5">
            Recent projects
          </p>
          <h2 className="text-3xl lg:text-4xl font-black tracking-tight text-slate-900">
            A few jobs we’re proud of.
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {projects.map((p, idx) => (
            <article
              key={p.title}
              className="group rounded-2xl overflow-hidden border border-slate-200 bg-white hover:shadow-lg transition-all"
              data-testid={`ws-project-${idx}`}
            >
              <div
                className="aspect-[4/3] relative overflow-hidden"
                style={{
                  background: `linear-gradient(135deg, ${swatch(idx)} 0%, ${swatch(idx + 1)}cc 100%)`,
                }}
              >
                <div
                  className="absolute inset-0 opacity-30 transition-opacity group-hover:opacity-50"
                  style={{
                    backgroundImage:
                      'repeating-linear-gradient(45deg, rgba(255,255,255,0.10) 0 2px, transparent 2px 14px)',
                  }}
                />
                <div className="absolute bottom-3 left-3 right-3 flex justify-between items-end">
                  <span className="text-[10px] font-bold uppercase tracking-wider text-white/90 bg-black/30 backdrop-blur-sm px-2 py-1 rounded">
                    {p.tag}
                  </span>
                  <span className="text-[10px] font-bold text-white/80">#{String(idx + 1).padStart(2, '0')}</span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-bold text-slate-900 leading-snug">{p.title}</h3>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
